import { DocumentSlug, AttributeSlug } from '../types/contents.ts';

export function genDocumentSlug(uuidV7: string): DocumentSlug {
  const id = uuidV7.replace(/-/g, '');

  if (uuidV7.length !== 36 || id.length !== 32) {
    return DocumentSlug.parse(uuidV7.slice(0, 24));
  }

  // unix_ts_ms: 12
  // ver: 1
  // rand_a: 3
  // var: 1
  // rand_b: 15
  // https://www.rfc-editor.org/rfc/rfc9562.html#name-uuid-version-7

  // タイムスタンプ部分: コンテンツにおいてミリ秒の精度は不要なため8文字に短縮
  const timestamp = id.slice(0, 8);

  // 乱数部分
  const random = id.slice(-16);

  return DocumentSlug.parse(timestamp + random);
}

export function genAttributeSlug(uuidV7: string): AttributeSlug {
  const id = uuidV7.replace(/-/g, '');

  if (uuidV7.length !== 36 || id.length !== 32) {
    return AttributeSlug.parse(uuidV7.slice(0, 16));
  }

  // unix_ts_ms: 12
  // ver: 1
  // rand_a: 3
  // var: 1
  // rand_b: 15
  // https://www.rfc-editor.org/rfc/rfc9562.html#name-uuid-version-7

  // タイムスタンプ部分: コンテンツにおいてミリ秒の精度は不要なため8文字に短縮
  const timestamp = id.slice(0, 8);

  // 乱数部分
  const random = id.slice(-16, -8);

  return AttributeSlug.parse(timestamp + random);
}
